import * as React from 'react';
// import type { SVGProps } from 'react';

function HomeIcon({ size = '1em', color='black', viewBox = '0 0 24 24', stokeWidth = 3 }: any) {
  const _color = color
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      viewBox={viewBox} 
      strokeWidth={stokeWidth}
      color={_color}
    >
      <path fill={_color} d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81zM12 3 2 12h3v8h6v-6h2v6h6v-8h3z"></path>
    </svg>
  );
}

export default HomeIcon;
